import React, {lazy} from 'react';
import {Route, Redirect, IndexRedirect, IndexRoute} from 'react-router';

import subjectRoutes from 'client/Dennis/V2/Subjects/routes';
import BatchRoutes from 'client/Dennis/BatchUtils/routes';

const GuideLevelPracticeView = lazy(
  () => import('./GuideLevelPracticeView/GuideLevelPracticeView.react')
);

const Dennis = lazy(() => import(/* webpackChunkName: "Dennis" */ './Dennis.react'));
/**
 * "Content" Components
 */
const Content = lazy(() => import('./Content/Content'));
const Queue = lazy(() => import('./Content/Queue/Queue.react'));
const SupplementManager = lazy(
  () => import('client/Supplements/SupplementManager/SupplementManager')
);
const Standards = lazy(() => import('./StandardsV2/Standards.react'));
/**
 * "Users" Components
 */
const Users2 = lazy(() => import('./Users2/Users'));
const UserSearchWrapper = lazy(() => import('./UserEdit2/UserEditSearchWrapper'));
const UserForm = lazy(() => import('./UserEdit2/UserForm/UserForm'));
const UserWrapper = lazy(() => import('./UserEdit2/Wrapper/UserFormWrapper'));
const UserSubscriptions = lazy(() => import('./UserEdit2/Subscriptions/UserSubscriptions'));
const UserAuthoringPermissions = lazy(
  () => import('./UserEdit2/Authoring/UserAuthoringPermissions')
);
const UserAccess = lazy(() => import('./UserAccess/UserAccess'));
/**
 * "Schools" Components
 */
const SchoolsLanding = lazy(() => import('./Schools/SchoolsLanding/SchoolsLanding.react'));
const SchoolsIndex = lazy(() => import('./Schools/SchoolsIndex/SchoolsIndex.react'));
const SchoolEdit = lazy(() => import('./Schools/SchoolsIndex/Edit/SchoolEdit'));
const SchoolCreate = lazy(() => import('./Schools/SchoolsIndex/Create/SchoolCreate'));
const SubjectGroupsIndex = lazy(() => import('./Schools/SubjectGroups/SubjectGroupsIndex.react'));
const SubjectGroupEdit = lazy(() => import('./Schools/SubjectGroups/Edit/SubjectGroupEdit.react'));
const SubjectGroupCreate = lazy(
  () => import('./Schools/SubjectGroups/Create/SubjectGroupCreate.react')
);

const DistrictsLanding = lazy(() => import('./Districts/DistrictsLanding'));
const DistrictsList = lazy(() => import('./Districts/DistrictsList'));
const DistrictEdit = lazy(() => import('./Districts/Edit/DistrictEdit'));
const DistrictCreate = lazy(() => import('./Districts/Create/DistrictCreate'));

import AuthorDashboardProvider from '../AuthorDashboard/AuthorDashboardProvider/AuthorDashboardProvider.react';
import sessionStore from '../Session/SessionStore';
const AuthorDashboard = lazy(() => import('../AuthorDashboard/AuthorDashboard.react'));

const AuthorDashboardWithContext = (props) => {
  return (
    <AuthorDashboardProvider>
      <AuthorDashboard {...props} />
    </AuthorDashboardProvider>
  );
};

const requireContentManager = (_nextState, replace) => {
  if (!sessionStore.hasContentManagerAccess()) {
    replace('/dennis/content/queue');
  }
};

const DennisRoutes = (
  <Route path='dennis' name='dennis' component={Dennis}>
    {BatchRoutes}
    <Route path='content' component={Content}>
      <Redirect from='question-set-search' to='queue' />
      <Redirect from='frq-queue' to='queue' />
      <IndexRedirect to='queue' />
      <Route
        path='queue(/:questionSetId)(/:questionId)'
        component={Queue}
        title='Queue | Albert.io'
      />
      <Route
        path='dashboard'
        component={AuthorDashboardWithContext}
        title='Authoring | Albert.io'
      />
      {subjectRoutes}
      <Route
        path='supplements'
        component={SupplementManager}
        title='Supplements | Albert.io'
        onEnter={requireContentManager}
      />
      <Route
        path='standards'
        component={Standards}
        title='Standards | Dennis | Albert.io'
        onEnter={requireContentManager}
      >
        {/* @todo: Make this work */}
        <Route path=':subjectId' component={Standards} />
      </Route>
    </Route>
    <Route path='users' component={Users2}>
      <IndexRedirect to='search' />
      <Route path='search' component={UserSearchWrapper} />
      <Route path='edit/:userId' component={UserWrapper} title='User Edit | Dennis | Albert.io'>
        <IndexRoute component={UserForm} />
        <Route
          path='subscriptions'
          title='User Subscriptions Edit | Dennis | Albert.io'
          component={UserSubscriptions}
        />
        <Route
          path='authoring-permissions'
          title='User Authoring Permissions Edit | Dennis | Albert.io'
          component={UserAuthoringPermissions}
        />
      </Route>
      <Route path='create' component={UserWrapper} title='User Create | Dennis | Albert.io'>
        <IndexRoute component={UserForm} />
      </Route>
      <Route path='access' component={UserAccess} title='User Access | Dennis | Albert.io' />
    </Route>
    <Route path='districts' component={DistrictsLanding}>
      <IndexRedirect to='districts-list' />
      <Route path='districts-list' component={DistrictsList} />
      <Route path='create' component={DistrictCreate} />
      <Route path='edit/:districtId' component={DistrictEdit} />
    </Route>
    <Route path='schools' component={SchoolsLanding}>
      <IndexRedirect to='school-list' />
      <Route path='school-list' component={SchoolsIndex} />
      <Route path='school-list/create' component={SchoolCreate} />
      <Route path='school-list/edit/:schoolId' component={SchoolEdit} />
      <Route path='subject-groups' component={SubjectGroupsIndex} />
      <Route path='subject-groups/create' component={SubjectGroupCreate} />
      <Route path='subject-groups/edit/:subjectGroupId' component={SubjectGroupEdit} />
    </Route>
    <Route path=':subjectSlug/:guideLevelSlug' component={GuideLevelPracticeView} />
  </Route>
);

export {DennisRoutes};
